import baseMixin from './baseMixin'
import { styler, tween, composite, chain, delay } from 'popmotion'

export default {
    mixins: [baseMixin],

    beforeCreate() {
        this.baseElementQueryString = 'commercial-alignment-graphic'
    },

    methods: {
        setStyler() {
            const paths = Array.from(
                this.baseElement.querySelectorAll('#ca-paths path')
            )

            this.whitePaths = []

            paths.forEach(p => {
                if (p.id === 'dollerydoo-path-orange') {
                    this.orangePath = styler(p)
                } else {
                    this.whitePaths.push(styler(p))
                }
            })

            this.flops = Array.from(
                this.baseElement.querySelectorAll('#flop, #flop_2')
            ).map(e => styler(e))

            this.dollerydoos = styler(
                this.baseElement.querySelector('#dollerydoos')
            )
        },

        initAction() {
            return composite({
                paths: tween({ from: 100, to: 0 }),
                goals: tween({ from: { opacity: 1 }, to: { opacity: 0 } })
            })
        },

        animationAction() {
            return composite({
                white: tween({ from: 0, to: 100, duration: 1500 }),
                orange: chain(
                    delay(1000),
                    tween({ from: 0, to: 100, duration: 1500 })
                ),
                goalsOpacity: chain(
                    delay(2000),
                    tween({ from: { opacity: 0 }, to: { opacity: 1 } })
                )
            })
        },

        initReaction(v) {
            if (v.paths) {
                let p = { pathLength: v.paths }

                this.orangePath.set(p)
                this.whitePaths.forEach(s => s.set(p))
            }
            if (v.goals) {
                this.flops.forEach(f => f.set(v.goals))
                this.dollerydoos.set(v.goals)
            }
        },

        animationReaction(values) {
            const { white, orange, goalsOpacity } = values
            white && this.whitePaths.forEach(s => s.set({ pathLength: white }))

            orange && this.orangePath.set({ pathLength: orange })

            if (goalsOpacity) {
                this.flops.forEach(f => f.set(goalsOpacity))
                this.dollerydoos.set(goalsOpacity)
            }
        }
    }
}
